"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.checkShouldValidate = checkShouldValidate;
var _utils = require("../../utils");
var _validateInput = require("../validate-input");
function checkShouldValidate(inputElement, eventType) {
  return function (getState, dispatch) {
    const {
      config
    } = getState();
    if (config.mode === _utils.MODE_TYPES[eventType]) {
      dispatch((0, _validateInput.validateInput)(inputElement));
    }
  };
}